import loadScript from './loadScript';
import {tongjiToken} from './config';

/* eslint-disable */
// 百度统计
window._hmt = window._hmt || [];
loadScript(`https://hm.baidu.com/hm.js?${tongjiToken}`);